module.exports = __webpack_public_path__ + "media/admin/logo-vindi-713f89a9.svg";